import React from 'react';
import { Card } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { distributionCostChartHighchartsOptions } from './distribution-cost-chart-highcharts-options';
import type { IDistributionCostChartProps } from './types';

export const DistributionCostChart: React.FC<IDistributionCostChartProps> = (props) => {
  const { title, series } = props;

  const options = distributionCostChartHighchartsOptions(series);

  return (
    <Card title={title}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
};
